"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popper = exports.UncontrolledPopper = exports.ControlledPopper = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_dom_1 = require("react-dom");
var react_popper_1 = require("react-popper");
var click_outside_1 = require("../../hooks/click-outside");
var theme_1 = require("../../theme");
var box_1 = require("../box");
var popover_animation_1 = require("../popover-animation");
function ControlledPopper(_a) {
    var isOpen = _a.isOpen, onToggle = _a.onToggle, children = _a.children, trigger = _a.trigger, offsetSkidding = _a.offsetSkidding, _b = _a.offsetDistance, offsetDistance = _b === void 0 ? 8 : _b, _c = _a.placement, placement = _c === void 0 ? 'bottom-end' : _c, portalElement = _a.portalElement, _d = _a.style, style = _d === void 0 ? {} : _d;
    var _e = (0, react_1.useState)(null), popoverRef = _e[0], setPopoverRef = _e[1];
    var triggerRef = (0, react_1.useRef)(null);
    var _f = (0, react_popper_1.usePopper)(triggerRef.current, popoverRef, {
        placement: placement,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [offsetSkidding, offsetDistance],
                },
            },
        ],
    }), attributes = _f.attributes, update = _f.update, styles = _f.styles;
    var toggle = function (newValue) {
        if (typeof newValue === 'boolean') {
            onToggle(newValue);
        }
        else {
            onToggle(!isOpen);
        }
    };
    (0, react_1.useEffect)(function () {
        if (update) {
            update();
        }
    }, [isOpen, update]);
    (0, click_outside_1.useOnClickOutside)(popoverRef, function (e) {
        if (isOpen && e.target !== triggerRef.current) {
            toggle(false);
        }
    });
    var popoverContent = (react_1.default.createElement("div", (0, tslib_1.__assign)({}, attributes.popper, { style: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles.popper), { width: style.width, zIndex: theme_1.zIndices.popover }), ref: setPopoverRef }),
        react_1.default.createElement(popover_animation_1.PopoverAnimation, { direction: "down", isOpen: isOpen },
            react_1.default.createElement(box_1.Box, { backgroundColor: "white", border: 1, borderRadius: 3, boxShadow: "overlay", style: style }, typeof children === 'function' ? children({ toggle: toggle }) : children))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        trigger && trigger({ toggle: toggle, triggerRef: triggerRef }),
        portalElement ? (0, react_dom_1.createPortal)(popoverContent, portalElement) : popoverContent));
}
exports.ControlledPopper = ControlledPopper;
function UncontrolledPopper(props) {
    var children = props.children, rest = (0, tslib_1.__rest)(props, ["children"]);
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    return (react_1.default.createElement(ControlledPopper, (0, tslib_1.__assign)({}, rest, { isOpen: isOpen, onToggle: function (newValue) { return setIsOpen(newValue); } }), children));
}
exports.UncontrolledPopper = UncontrolledPopper;
function Popper(props) {
    var onToggle = props.onToggle, isOpen = props.isOpen, children = props.children, rest = (0, tslib_1.__rest)(props, ["onToggle", "isOpen", "children"]);
    var isControlled = typeof isOpen !== 'undefined';
    if (isControlled) {
        var toggle = typeof onToggle === 'function' ? onToggle : function () { };
        return (react_1.default.createElement(ControlledPopper, (0, tslib_1.__assign)({}, rest, { onToggle: toggle, isOpen: isOpen }), children));
    }
    return react_1.default.createElement(UncontrolledPopper, (0, tslib_1.__assign)({}, rest), children);
}
exports.Popper = Popper;
//# sourceMappingURL=index.js.map